import { TEDCustomDateTimeParser } from './TEDCustomDateTimeParser';
import { TEDParseDateTimeMode } from '../FormatterTypes';

export class TEDParseTime extends TEDCustomDateTimeParser {
  public static getInstance(): TEDParseTime {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDParseTime;

  public mode() {
    return TEDParseDateTimeMode.pdmHMS;
  }
}
